import { Link } from "react-router-dom";
import { scoops } from "@/mocks/scoops";
import VerdictBadge from "@/components/base/VerdictBadge";

export default function DebunkList() {
  const list = scoops.filter((item) => item.verdict === "refuted" || item.verdict === "unverified");

  return (
    <ul className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {list.map((item) => (
        <li key={item.id}>
          <Link
            to={`/scoop/${item.id}`}
            className="group flex flex-col gap-3 px-5 py-5 transition-colors hover:bg-background-100 sm:flex-row sm:items-center sm:gap-5 md:px-6"
          >
            <span className="shrink-0">
              <VerdictBadge verdict={item.verdict} size="sm" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-heading text-[15px] leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                {item.title}
              </span>
              <span className="mt-1 block font-label text-[11px] text-foreground-500">
                {item.code} · {item.category} · 可信度 {item.credibility}
              </span>
            </span>
            <span className="flex shrink-0 items-center gap-1 font-label text-[12px] text-primary-600">
              查看辨析
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}